import { render, staticRenderFns } from "./individualMember.vue?vue&type=template&id=58508ece&scoped=true&"
import script from "./individualMember.vue?vue&type=script&lang=js&"
export * from "./individualMember.vue?vue&type=script&lang=js&"
import style0 from "./individualMember.vue?vue&type=style&index=0&id=58508ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58508ece",
  null
  
)

export default component.exports